import React, { ReactElement } from 'react';
import { Button, ButtonVariant, Icon, Typography } from '@packages/ui/shared';
import { FC } from 'react';
import Modal from 'react-bootstrap/Modal';

export interface WorksheetModal3ButtonProps {
    show: boolean;
    onHideModal: () => void;
    handleAction: (action: 'left' | 'middle' | 'right') => void;
    warningMessage?: string;
    title?: string;
    bodyMessage?: string | ReactElement;
    leftButton: string;
    leftButtonVariant?: ButtonVariant;
    leftButtonLoading?: boolean;
    middleButton: string;
    middleButtonVariant?: ButtonVariant;
    middleButtonLoading?: boolean;
    rightButton: string;
    rightButtonVariant?: ButtonVariant;
    rightButtonLoading?: boolean;
    closeButton?: boolean;
}

export const WorksheetModal3Button: FC<WorksheetModal3ButtonProps> = ({
    show,
    onHideModal,
    handleAction,
    warningMessage,
    title,
    bodyMessage,
    leftButton,
    leftButtonVariant,
    leftButtonLoading,
    middleButton,
    middleButtonVariant,
    middleButtonLoading,
    rightButton,
    rightButtonVariant,
    rightButtonLoading,
    closeButton,
}) => {
    return (
        <Modal show={show} centered={true} onHide={onHideModal}>
            {title && (
                <Modal.Header closeButton={closeButton}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            )}

            <Modal.Body>
                {warningMessage && (
                    <div className="d-flex align-items-center mb-2">
                        <Icon name="warning" color="black" style={{ marginRight: 5 }} />
                        <Typography style={{ fontWeight: 'bold' }}>{warningMessage}</Typography>
                    </div>
                )}
                {bodyMessage && <Typography>{bodyMessage}</Typography>}
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-between">
                <Button
                    variant={leftButtonVariant || 'ghost-blue'}
                    onPress={() => handleAction('left')}
                    isLoading={leftButtonLoading}
                    disabled={leftButtonLoading}
                >
                    {leftButton}
                </Button>
                <div className="d-flex gap-2">
                    <Button
                        variant={middleButtonVariant || 'ghost-blue'}
                        onPress={() => handleAction('middle')}
                        isLoading={middleButtonLoading}
                        disabled={middleButtonLoading}
                    >
                        {middleButton}
                    </Button>
                    <Button
                        variant={rightButtonVariant || 'primary'}
                        onPress={() => handleAction('right')}
                        isLoading={rightButtonLoading}
                        disabled={rightButtonLoading}
                    >
                        {rightButton}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
